import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../auth.service';
import { EnvironmentService } from '../environment.service';

@Injectable({
  providedIn: 'root',
})
export class OtMasterService {
  apiBaseURL!: string;
  constructor(
    private readonly http: HttpClient,
    private readonly auth: AuthService,
    private readonly env: EnvironmentService
  ) {
    this.apiBaseURL = env.getApiEndpoint();
  }

  createOt(formData: FormData): Observable<any> {
    return this.http.post<any>(this.apiBaseURL + 'otmaster', formData);
  }

  getAllOtList(params: any): Observable<any> {
    let options = {
      params: new HttpParams({ fromObject: params })
    }
    return this.http.get<any>(this.apiBaseURL + 'otmaster', options);
  }
  getAllOtListWithPagi(params: any): Observable<any> {
    let options = {
      params: new HttpParams({ fromObject: params })
    }
    return this.http.get<any>(this.apiBaseURL + 'otmaster/listWithPagination', options);
  }

  getOtById(id: any): Observable<any> {
    return this.http.get<any>(this.apiBaseURL + 'otmaster/' + id);
  }

  updateOtMaster(id: any, formData: any): Observable<any> {
    return this.http.put<any>(this.apiBaseURL + 'otmaster/' + id, formData);
  }

  deleteMenu(id: any): Observable<any> {
    return this.http.delete<any>(this.apiBaseURL + 'otmaster/' + id);
  }
}
